import {
  apiRegister
} from '../../common/api';

/*
协议Id 
894
项目 
模块 
方式 
https 
命令（路径） 
/award/match/mydetail/
说明
我的进展接口
*/

const myDetail = apiRegister('myDetail',  {
  protoId: 894,
  path: '/award/match/mydetail/',
  // checkResult(R) {
  //   if (!isPlain(R.info)) {
  //     return ERR_REP_MY_DETAIL // 数据格式非法
  //   }
  //   return 0
  // },
  formatResult(R) {
    const {info} = R
    if(info) {
      if(info.status === 1) {// 0代表正常1代表失效
        info.preRank = -999  // 临时用来表示已失效排名
        info.preScore = '无效'
        info.maxAvgScore = '无效'
      }
    }
    return R
  }
})

export const myDetailLoad = myDetail.send

/*
协议Id 
912
项目 
模块 
方式 
https 
命令（路径） 
/award/match/sinaisbind/
说明
检测是否有绑定新浪
请求参数
参数名称	参数类型	说明
cId	int	比赛配置id
*/

	
const myOpenId = apiRegister('myOpenId',  {
  protoId: 912,
  path: '/award/match/sinaisbind/',
  // checkResult(R) {
  //   if (!isPlain(R.info)) {
  //     return ERR_REP_MY_DETAIL // 数据格式非法
  //   }
  //   return 0
  // },
  formatResult(R) {
    return R
  }
})

export const myOpenIdLoad = myOpenId.send
